import store from '@/store'
import config from '@/config'
const isDebug = sessionStorage.geolocationDebug
const PROVIDER = config.app.autoconf.GEOLOCATION.PROVIDER
const ERROR_MSG_CODE = ['ERROR_VERIFY_APP', 'BROWSER_LOCATION_DENIED']

async function resolveMockupGeolocation (param) {
  console.info(' ----- MOCKUP GEOLOCATION -----')
  let errorCode = 'verify'
  store.commit('overlayState/setGeolocationMessage', { errorCode })
  return new Promise((resolve, reject) => setTimeout(() => {
    param ? resolve(true) : resolve(false)
  }, 5000))
}

function setMockupGeolocation (param) {
  if (param) {
    localStorage.setItem('gcPerm', true)
    store.commit('setGeolocated', true)
    localStorage.setItem('geoError', false)
    store.dispatch('triggerBSLocationVerifiedAnimation', true)
    store.commit('overlayState/setGeolocationMessage', {})
    return false
  }
  store.commit('overlayState/setGeolocationMessage', {})
  localStorage.setItem('gcPerm', false)
  store.commit('setGeolocated', false)
  let errorCode = 999
  let errorMessage = ''
  localStorage.setItem('geoError', errorCode)
  store.commit('overlayState/setGeolocationMessage', { errorCode, errorMessage })
  store.dispatch('overlayState/activeGeolocationDialog')
}

/* show spinner on geolocation start */
function showSpinnerOnStart () {
  let errorCode = 'verify'
  store.commit('setGeolocationOnLogin', true)
  store.commit('setOnLoginGeolocationProgress', 'start')
  store.commit('overlayState/setGeolocationMessage', { errorCode })
}

/* before starting geolocation again, unset geo error */
function resetGeoError (reason) {
  if (isDebug && reason !== 'Login') console.log(`[${PROVIDER}] reset GeoError.`)
  if (typeof localStorage !== 'undefined') {
    if (localStorage.getItem('geoError')) {
      localStorage.setItem('geoError', false)
    }
  }
}

function resetGeolocationState () {
  localStorage.removeItem('tgc')
  localStorage.setItem('gcPerm', false)
  store.commit('setGeolocated', false)
}

function errorHandler (errorCode, errorMessage, userID, reason, browser = null) {
  let errCode = getErrorCode(errorCode)
  geolocationTechnicalError(errCode, errorMessage, userID, reason)
  var isCode = ERROR_MSG_CODE.includes(errorCode)
  if (isCode) {
    resetGeolocationState()
    if (ERROR_MSG_CODE.includes(612) || (errorCode === 'ERROR_VERIFY_APP')) {
      errorCode = 612
      localStorage.setItem('geoError', 612)
    }
    displayErrorMessage(errorCode, errorMessage, userID, browser)
  }
}

/** --------------------------------
 *  user is not geolocated or plugin not exist ; provide message to the user
 -------------------------------- **/
function displayErrorMessage (errorCode, errorMessage, userID, browser, showTryAgain = false) {
  localStorage.setItem('geoError', errorCode)
  store.commit('overlayState/setGeolocationMessage', { errorCode, errorMessage, browser, userID, showTryAgain })
  store.dispatch('overlayState/activeGeolocationDialog')
}

async function geolocationTechnicalError (errorCode, errorMessage, userID, reason) {
  let attemptID = await requestAttemptId()
  let keyName = errorCode
  let logReason = 'Desktop: Sports/ ' + reason
  store.dispatch('completeGeolocAttempt', {errorCode, errorMessage, userID, logReason, keyName, attemptID})
}

function detectBrowser () {
  const ua = navigator.userAgent
  if (ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR')) {
    return 'Chrome'
  } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
    return 'Safari'
  } else if (ua.includes('Firefox')) {
    return 'Firefox'
  } else if (ua.includes('Edg')) {
    return 'Edge'
  } else if (ua.includes('OPR') || ua.includes('Opera')) {
    return 'Opera'
  } else {
    return 'Default'
  }
}

async function detectBrowserModern () {
  if (navigator.userAgentData && navigator.userAgentData.brands) {
    const brands = navigator.userAgentData.brands.map(b => b.brand)
    console.log('xpoint brands', brands)
    if (brands.some(b => b.includes('Chrome')) && !brands.some(b => b.includes('Edge'))) {
      return 'Chrome'
    }
    if (brands.some(b => b.includes('Edge'))) {
      return 'Edge'
    }
    if (brands.some(b => b.includes('Opera'))) {
      return 'Opera'
    }
    if (brands.some(b => b.includes('Brave'))) {
      return 'Brave'
    }
    return 'Default'
  } else {
    return detectBrowser()
  }
}

async function requestAttemptId () {
  if (!window.ctsautoconf.ENABLE_GEOLOCATION_ATTEMPT_REQUESTS) return true
  let attemptID = store.getters['getGeolocationAttempt']
  if (attemptID) return attemptID
  return store.dispatch('initGeolocAttempt')
}

function getErrorCode (errorCode) {
  if (Number.isInteger(errorCode)) {
    return errorCode
  }
  const num = Number(errorCode)
  if (Number.isInteger(num)) {
    return num
  }
  return null
}

export default {
  resolveMockupGeolocation,
  setMockupGeolocation,
  showSpinnerOnStart,
  resetGeoError,
  errorHandler,
  detectBrowserModern,
  requestAttemptId,
  resetGeolocationState,
  displayErrorMessage
}



// WEBPACK FOOTER //
// ./src/library/geolocation/services/common/utils.js